export default __webpack_public_path__ + "static/media/lionshare.35bfa97e.png";